export const PINReaders_TYPE_REQUEST = "PINReaders_TYPE_REQUEST";
export const PINReaders_TYPE_SUCCESS = "PINReaders_TYPE_SUCCESS";
export const PINReaders_TYPE_FAILURE = "PINReaders_TYPE_FAILURE";

export const PINReaders_UPDATE_REQUEST = "PINReaders_UPDATE_REQUEST";
export const PINReaders_UPDATE_SUCCESS = "PINReaders_UPDATE_SUCCESS";
export const PINReaders_UPDATE_FAILURE = "PINReaders_UPDATE_FAILURE";
export const PINReaders_UPDATE_RESET = "PINReaders_UPDATE_RESET";
